import type { ReactNode } from "react";
import { memo } from "react";
import { Autocomplete, TextField } from "@mui/material";
import type Article from "models/Article";

type ArticleInputCommonProps = {
  availableArticles: Array<Article>;
};
type ArticleInputUniqueProps = {
  multiple?: never;
  unique: boolean;
  selectedArticles?: never;
  selectedArticle: Article | null;
  setSelectedArticles?: never;
  setSelectedArticle: (a: Article | null) => void;
};
type ArticleInputMultipleProps = {
  multiple: boolean;
  unique?: never;
  selectedArticles: Array<Article>;
  selectedArticle?: never;
  setSelectedArticles: (a: Array<Article>) => void;
  setSelectedArticle?: never;
};

type ArticleInputProps = ArticleInputCommonProps &
  (ArticleInputUniqueProps | ArticleInputMultipleProps);

const ArticleInput = memo(function ArticleInput({
  selectedArticle,
  selectedArticles,
  setSelectedArticle,
  setSelectedArticles,
  availableArticles,
  multiple = false,
  unique = false,
}: Readonly<ArticleInputProps>): ReactNode {
  return (
    <Autocomplete
      fullWidth
      multiple={multiple}
      options={availableArticles}
      onChange={(_e, newValue) => {
        if (unique && setSelectedArticle != null) {
          setSelectedArticle(newValue as Article | null);
        }
        if (multiple && setSelectedArticles != null) {
          setSelectedArticles(newValue as Array<Article>);
        }
      }}
      value={selectedArticle ?? selectedArticles ?? null}
      renderInput={(params) => (
        <TextField {...params} label="Nom d'un article" placeholder="Nom d'un article" />
      )}
      limitTags={3}
      size="small"
    />
  );
});

export default ArticleInput;
